import React from 'react';
import { Collapse, List } from '@mui/material';
import { useSidebar } from '../hook/useSidebar';
import SidebarItem from '../SidebarItem';
import SidebarItemExpendable from '../SidebarItemExpendable';
import { MedicalServices } from '@mui/icons-material';
import { usePermissionRules } from 'hooks/permissionRules';

const Ambulatory: React.FC = () => {
  const { handleCollapseClick, collapsible } = useSidebar();
  const { checkPermission } = usePermissionRules();

  return (
    <>
      <SidebarItemExpendable
        onClick={() => handleCollapseClick('ambulatory')}
        text="Ambulatório"
        opened={collapsible.ambulatory}
        icon={<MedicalServices />}
      />
      <Collapse in={collapsible.ambulatory}>
        <List disablePadding>
          {checkPermission('ambulatory.guides') && <SidebarItem nested={5} to="/guides" text="Guias" />}
          {checkPermission('ambulatory.consultation') && <SidebarItem nested={5} to="/consultation" text="Consultas" />}
        </List>
      </Collapse>
    </>
  );
};

export default Ambulatory;
